export const isWindowMenubar = (): boolean => {
    return (
        (window.todesktop || window.location.origin.includes("localhost")) && window.location.href.includes("menubar")
    );
};
